module.exports = __webpack_public_path__ + "img/flight_white.bfc72bcc.svg";